import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_SURVEYSCORE,
  DELETE_SURVEYSCORE,
  UPDATE_SURVEYSCORE,
  ADD_NEW_SURVEYSCORE,
} from "./actionType";

import {
  getSurveyScoreSuccess,
  getSurveyScoreFail,
  deleteSurveyScoreSuccess,
  deleteSurveyScoreFail,
  updateSurveyScoreSuccess,
  updateSurveyScoreFail,
  addSurveyScoreSuccess,
  addSurveyScoreFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveSurveyScoreApi,
  getSurveyScoreApi,
  updateSurveyScoreApi,
  deleteSurveyScoreApi,
  addNewSurveyScoreApi,
} from "../../helpers/backend_helper";

function* getSurveyScore({ payload: surveyScore }) {
  try {
    const response = yield call(getSurveyScoreApi, surveyScore);
    yield put(getSurveyScoreSuccess(GET_SURVEYSCORE, response.data));
  } catch (error) {
    yield put(getSurveyScoreFail(GET_SURVEYSCORE, error));
  }
}

function* onUpdateSurveyScore({ payload: surveyScore }) {
  try {
    if (surveyScore.setApprove) {
      const response = yield call(approveSurveyScoreApi, surveyScore);
      yield put(updateSurveyScoreSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateSurveyScoreApi, surveyScore);
      yield put(updateSurveyScoreSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSurveyScoreFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSurveyScore({ payload: surveyScore }) {
  try {
    const response = yield call(deleteSurveyScoreApi, surveyScore);
    yield put(deleteSurveyScoreSuccess({ surveyScore, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSurveyScoreFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSurveyScore({ payload: surveyScore }) {
  try {
    const response = yield call(addNewSurveyScoreApi, surveyScore);
    yield put(addSurveyScoreSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSurveyScoreFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetSurveyScore() {
  yield takeEvery(GET_SURVEYSCORE, getSurveyScore);
}

export function* watchUpdateSurveyScore() {
  yield takeEvery(UPDATE_SURVEYSCORE, onUpdateSurveyScore);
}

export function* watchDeleteSurveyScore() {
  yield takeEvery(DELETE_SURVEYSCORE, onDeleteSurveyScore);
}

export function* watchAddNewSurveyScore() {
  yield takeEvery(ADD_NEW_SURVEYSCORE, onAddNewSurveyScore);
}

function* surveyScoreSaga() {
  yield all([
    fork(watchGetSurveyScore),
    fork(watchDeleteSurveyScore),
    fork(watchUpdateSurveyScore),
    fork(watchAddNewSurveyScore),
  ]);
}

export default surveyScoreSaga;
